import { computed } from 'vue';
import { sumBy } from 'lodash';

import type { NotificationSource } from './types';

/** Combines every source, so the bell never depends on a specific one. */
export function useNotificationCenter(sources: NotificationSource[]) {
  const attentionCount = computed(() => sumBy(sources, source => source.attentionCount.value));
  const hasAttention = computed(() => attentionCount.value > 0);
  const hasUnseen = computed(() => sources.some(source => source.hasUnseen.value));

  // With a single source there is no center to show yet, so the bell toggles the source itself
  const toggle = () => {
    sources[0]?.toggle();
  };

  return {
    sources,
    attentionCount,
    hasAttention,
    hasUnseen,
    toggle
  };
}
